import React from 'react'
import PropTypes from 'prop-types'

import isEmpty from 'lodash/isEmpty'
import last from 'lodash/last'
import sortBy from 'lodash/sortBy'
import Spinner from '@vtex/styleguide/lib/Spinner'

import { excludeCheckInFromSlas } from '@/checkout-instore-legacy/utils/checkInUtils'
import {
  isPickUpAvailable,
  isDeliveryAvailable,
} from '@/checkout-instore-legacy/cart/simulation/utils'

import ItemShippingTable from './ItemShippingTable'
import { extractItemsForPickupPoint, extractItemsForDelivery } from './utils'

function getLogisticsInfoWithMostQuantity(logisticsInfo) {
  const sortedByQuantitylogisticsInfo = sortBy(logisticsInfo, 'quantity')
  return last(sortedByQuantitylogisticsInfo)
}

function getDeliveryTableItemsFromLogisticsInfo(logisticsInfo) {
  if (isEmpty(logisticsInfo)) {
    return []
  }
  const filteredSLAS = excludeCheckInFromSlas(logisticsInfo.slas)
  return extractItemsForDelivery(filteredSLAS)
}

function getPickUpTableItemsFromLogisticsInfo(logisticsInfo) {
  if (isEmpty(logisticsInfo)) {
    return []
  }
  const filteredSLAS = excludeCheckInFromSlas(logisticsInfo.slas)
  return extractItemsForPickupPoint(filteredSLAS)
}

function ItemShippingInfoAid({ logisticsInfo, isLoading, quantity }) {
  const logisticsInfoWithMostQuantity = getLogisticsInfoWithMostQuantity(
    logisticsInfo
  )
  const deliveryItems = isDeliveryAvailable(logisticsInfo, quantity)
    ? getDeliveryTableItemsFromLogisticsInfo(logisticsInfoWithMostQuantity)
    : []

  const pickUpItems = isPickUpAvailable(logisticsInfo, quantity)
    ? getPickUpTableItemsFromLogisticsInfo(logisticsInfoWithMostQuantity)
    : []

  if (isLoading) {
    return (
      <div className="tc pt6">
        <Spinner />
      </div>
    )
  }

  return (
    <div>
      <div data-cy="delivery-shipping-table">
        <ItemShippingTable
          items={deliveryItems}
          titleId="product.shippingAid.delivery.tableTitle"
        />
      </div>
      {!isEmpty(pickUpItems) ? (
        <div className="pt7" data-testid="pick-up-shipping-table">
          <ItemShippingTable
            items={pickUpItems}
            titleId="product.shippingAid.pickUp.tableTitle"
          />
        </div>
      ) : null}
    </div>
  )
}

ItemShippingInfoAid.propTypes = {
  logisticsInfo: PropTypes.array,
  isLoading: PropTypes.bool,
  quantity: PropTypes.number.isRequired,
}

export default ItemShippingInfoAid
